import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ResourcesSection = () => {
  const resources = [
    {
      id: 1,
      title: "React Performance Optimization Checklist",
      description: "Comprehensive guide covering 25+ optimization techniques for production React applications",
      icon: "FileCheck",
      type: "PDF Guide",
      size: "2.4 MB"
    },
    {
      id: 2,
      title: "Full-Stack Architecture Templates",
      description: "Production-ready boilerplates for Node.js, React, and database integration patterns",
      icon: "FolderArchive",
      type: "Code Templates",
      size: "15 MB"
    },
    {
      id: 3,
      title: "API Security Best Practices",
      description: "Essential security checklist for REST and GraphQL APIs with implementation examples",
      icon: "Shield",
      type: "PDF Guide",
      size: "1.8 MB"
    }
  ];

  return (
    <section className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground mb-3">
          Free Developer Resources
        </h2>
        <p className="text-base md:text-lg text-muted-foreground">
          Download practical guides and templates to accelerate your development workflow
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {resources?.map((resource) => (
          <div
            key={resource?.id}
            className="bg-card border border-border rounded-lg p-6 hover:shadow-lg hover:border-primary/50 transition-all duration-300"
          >
            <div className="flex items-start gap-4 mb-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10 flex-shrink-0">
                <Icon name={resource?.icon} size={24} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-lg font-bold font-heading text-foreground mb-1 line-clamp-2">
                  {resource?.title}
                </h3>
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <span>{resource?.type}</span>
                  <span>•</span>
                  <span>{resource?.size}</span>
                </div>
              </div>
            </div>

            <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
              {resource?.description}
            </p>

            <Button
              variant="outline"
              iconName="Download"
              iconPosition="left"
              fullWidth
            >
              Download Free
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ResourcesSection;